import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { MechanismReveal } from './components/MechanismReveal';
import { DreamOutcome } from './components/DreamOutcome';
import { FailedSolutions } from './components/FailedSolutions';
import { ProductReveal } from './components/ProductReveal';
import { OriginStory } from './components/OriginStory';
import { BonusSection } from './components/BonusSection';
import { PricingCTA } from './components/PricingCTA';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-brand-dark font-sans selection:bg-brand-rose selection:text-white overflow-x-hidden" data-id="element-0">
      <main data-id="element-1">
        <Hero data-id="element-2" />
        <PainPoints data-id="element-3" />
        <MechanismReveal data-id="element-4" />
        <DreamOutcome data-id="element-5" />
        <FailedSolutions data-id="element-6" />
        <ProductReveal data-id="element-7" />
        <BonusSection data-id="element-8" />
        <PricingCTA data-id="element-9" />
        <OriginStory data-id="element-10" />
        <FinalCTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}